"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var LabelIcon = function LabelIcon(props) {
  return _react["default"].createElement("svg", {
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 84",
    width: props.width || "70px",
    height: props.height || "70px"
  }, _react["default"].createElement("defs", null, _react["default"].createElement("polygon", {
    points: "0 0 83.99985 0 83.99985 84 0 84"
  })), _react["default"].createElement("g", null, _react["default"].createElement("g", {
    transform: "translate(-108.000000, -108.000000)"
  }, _react["default"].createElement("g", {
    transform: "translate(108.000000, 108.000000)"
  }, _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M43.6031,84 C43.0911,84 42.5801,83.805 42.1891,83.414 L36.3741,77.6 C35.5931,76.818 35.5931,75.553 36.3741,74.771 C37.1561,73.99 38.4211,73.99 39.2031,74.771 L43.6031,79.172 L79.1711,43.604 L39.5681,4 L4.2611,4 C4.1171,4 3.9991,4.119 3.9991,4.264 L4.0011,39.574 L29.2011,64.77 C29.9821,65.551 29.9821,66.816 29.2011,67.598 C28.4191,68.379 27.1541,68.379 26.3731,67.598 L0.5871,41.816 C0.2121,41.441 0.0011,40.934 0.0011,40.402 L-0.0009,4.264 C-0.0009,1.912 1.9121,0 4.2611,0 L40.3961,0 C40.9271,0 41.4351,0.211 41.8101,0.586 L83.4141,42.189 C84.1951,42.971 84.1951,44.236 83.4141,45.018 L45.0171,83.414 C44.6261,83.805 44.1151,84 43.6031,84",
    fill: props.fill || "#71c4ff"
  })), _react["default"].createElement("path", {
    d: "M38.5895,25.1797 C31.1945,25.1797 25.1795,31.1957 25.1795,38.5897 C25.1795,45.9847 31.1945,51.9997 38.5895,51.9997 C45.9845,51.9997 51.9995,45.9847 51.9995,38.5897 C51.9995,31.1957 45.9845,25.1797 38.5895,25.1797 M38.5895,55.9997 C28.9895,55.9997 21.1795,48.1897 21.1795,38.5897 C21.1795,28.9907 28.9895,21.1797 38.5895,21.1797 C48.1895,21.1797 55.9995,28.9907 55.9995,38.5897 C55.9995,48.1897 48.1895,55.9997 38.5895,55.9997",
    fill: props.fill || "#71c4ff"
  }), _react["default"].createElement("path", {
    d: "M30.0025,71.5004 C30.0025,70.1194 31.1215,69.0004 32.5025,69.0004 C33.8835,69.0004 35.0025,70.1194 35.0025,71.5004 C35.0025,72.8814 33.8835,74.0004 32.5025,74.0004 C31.1215,74.0004 30.0025,72.8814 30.0025,71.5004",
    fill: props.fill || "#71c4ff"
  }), _react["default"].createElement("path", {
    d: "M8.4635,9.7804 C8.4635,8.3994 9.5825,7.2804 10.9635,7.2804 C12.3445,7.2804 13.4635,8.3994 13.4635,9.7804 C13.4635,11.1614 12.3445,12.2804 10.9635,12.2804 C9.5825,12.2804 8.4635,11.1614 8.4635,9.7804",
    fill: props.fill || "#71c4ff"
  })))));
};

var _default = LabelIcon;
exports["default"] = _default;